<script>
import {
  pageMonCompteMesProduitsHabituelsProps,
  usePageMonCompteMesProduitsHabituels
} from "./mixin";
import CoursesExpressProductList from "@/components/organisms/mon-compte/courses-express-product-list/mobile";
import Button from "@/components/atoms/button";
import CategoriesList from "@/containers/faire-mes-courses";
import LazyImage from "@/components/atoms/lazy-image";
import Divider from "@/components/atoms/divider";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";
import StateOverlay from "@/components/molecules/state-overlay";
import ListeDeCoursesSupprimerProduit from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-supprimer-produit";

import illustrationCrayonFeuille from "@/assets/images/illustration-crayon-feuille.svg";
import illustrationProduitsCoeurInterrogation from "@/assets/images/illustration-produits-coeur-interrogation.svg";

export default {
  name: "ProduitsHabituelsMobile",
  components: {
    CoursesExpressProductList,
    Button,
    CategoriesList,
    LazyImage,
    Card,
    Divider,
    Titre,
    StateOverlay,
    ListeDeCoursesSupprimerProduit
  },
  props: {
    ...pageMonCompteMesProduitsHabituelsProps()
  },
  setup(props, context) {
    const productList = ref();
    const supprimerProduit = ref();

    const {
      isLoading,
      liste,
      meta,
      noProduct,
      addToCartListe,
      addToCartProduits,
      deleteProduits,
      confirmDeleteProduits,
      mounted
    } = usePageMonCompteMesProduitsHabituels(
      props,
      context,
      supprimerProduit,
      productList
    );

    onMounted(mounted);

    return {
      isLoading,
      liste,
      meta,
      noProduct,
      addToCartListe,
      addToCartProduits,
      deleteProduits,
      confirmDeleteProduits,
      illustrationCrayonFeuille,
      illustrationProduitsCoeurInterrogation,
      productList,
      supprimerProduit
    };
  }
};
</script>

<template>
  <StateOverlay
    overlay
    :is-loading="isLoading || pageIsLoading"
  >
    <div>
      <Titre
        tag="h1"
        variant="primary"
        class="u-mb-md u-ml-sm"
      >
        Mes produits habituels
      </Titre>

      <div
        v-if="!noProduct"
        class="u-flex u-flex-align-center u-mb-lg u-ml-sm u-mr-sm"
      >
        <p class="u-text-20 u-mr-sm ">
          {{ liste.attributes.nb_produits }} {{ pluralize(liste.attributes.nb_produits, 'produit') }}
        </p>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          @click="addToCartListe"
        >
          Ajouter tout au panier
        </Button>
      </div>

      <Card
        radius="md"
        elevation="sm"
      >
        <CoursesExpressProductList
          v-if="!noProduct"
          ref="productList"
          can-delete
          :cart-context="trackingCodes.LABELGA.ProduitsHabituels"
          class="u-mt-md"
          :items="liste.attributes.produits.data"
          :sections="meta.sections.valeurs"
          @addToCart="addToCartProduits"
          @delete="deleteProduits"
        />
        <div
          v-else
          class="u-p-md"
        >
          <div class="u-text-center u-mb-md">
            <LazyImage
              :src="illustrationProduitsCoeurInterrogation"
              class="u-inline-block"
              width="102"
              height="71"
            />
            <Titre
              tag="h2"
              size="sm"
              class="u-mb-xs"
            >
              Vous n'avez pas encore de produit habituel
            </Titre>
            <p class="u-font-15">
              Retrouvez ici les produits que vous achetez le plus souvent et simplifiez-vous les courses !
            </p>
          </div>
          <Divider dotted />
          <h2 class="u-color-primary u-mb-md u-mt-md u-text-center">
            Commencez vos courses !
          </h2>
          <CategoriesList />
        </div>
      </Card>

      <div
        v-if="noProduct"
        class="u-mt-xlg u-mb-xlg"
      >
        <Titre
          tag="h2"
          size="sm"
          variant="primary"
          class="u-mb-xs u-text-center"
        >
          N'oubliez pas vos listes
        </Titre>
        <div class="u-flex u-flex-align-center">
          <LazyImage
            :src="illustrationCrayonFeuille"
            class="u-flex-item-none"
            width="77"
            height="60"
          />
          <div class="u-ml-xs u-mr-sm u-font-15">
            <p>
              Retrouvez facilement vos produits grâce à la création de listes illimitée
            </p>
          </div>
        </div>
        <div class="u-text-center u-mt-md">
          <Button
            variant="primary"
            radius="full"
            size="sm"
            class="u-flex-shrink-none"
            to="/mon-compte/mes-listes-de-courses"
          >
            Voir mes listes
          </Button>
        </div>
      </div>
      <ListeDeCoursesSupprimerProduit
        ref="supprimerProduit"
        is-produits-habituels
        :is-loading="isLoading"
        @confirmDelete="confirmDeleteProduits"
      />
    </div>
  </StateOverlay>
</template>

<style lang="scss" scoped>
</style>
